"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var InfoIconV4_1 = __importDefault(require("relements/build/esm/ui/icons/InfoIconV4"));
var TickIconV2_1 = __importDefault(require("relements/build/esm/ui/icons/TickIconV2"));
var CloseIconV4_1 = __importDefault(require("relements/build/esm/ui/icons/CloseIconV4"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
var upload_1 = require("relements/build/esm/api/upload");
var utils_1 = require("@src/utils");
// Constants
var constants_1 = require("../constants");
// Utils
var utils_2 = require("./utils");
// Components
var styledComponents_1 = require("./styledComponents");
var FileUpload = function (_a) {
    var value = _a.value, options = _a.options, onChange = _a.onChange, businessDataEdited = _a.businessDataEdited, businessId = _a.businessId;
    var _b = react_1.useState(value), fileUploadData = _b[0], setFileUploadData = _b[1];
    var _c = react_1.useState('initial'), testStatus = _c[0], setTestStatus = _c[1];
    var FILE_UPLOAD_DETAILS = constants_1.INPUT_BLOCK_KEYS.FILE_UPLOAD_DETAILS, CUSTOM_S3_BUCKET_DETAILS = constants_1.INPUT_BLOCK_KEYS.CUSTOM_S3_BUCKET_DETAILS, ALLOWED_S3_REGIONS = constants_1.INPUT_BLOCK_KEYS.ALLOWED_S3_REGIONS, IS_CUSTOM_BUCKET_ENABLED = constants_1.INPUT_BLOCK_KEYS.IS_CUSTOM_BUCKET_ENABLED, S3_BUCKET_NAME = constants_1.INPUT_BLOCK_KEYS.S3_BUCKET_NAME, BUCKET_ARN = constants_1.INPUT_BLOCK_KEYS.BUCKET_ARN, BUCKET_REGION = constants_1.INPUT_BLOCK_KEYS.BUCKET_REGION, EXPIRY = constants_1.INPUT_BLOCK_KEYS.EXPIRY, OBJECT_ACL = constants_1.INPUT_BLOCK_KEYS.OBJECT_ACL, DIRECTORY = constants_1.INPUT_BLOCK_KEYS.DIRECTORY, ALLOWED_OBJECT_ACLS = constants_1.INPUT_BLOCK_KEYS.ALLOWED_OBJECT_ACLS;
    var isSuccessful = testStatus === 'success';
    var isFailure = testStatus === 'failure';
    var isInitial = testStatus === 'initial';
    var isLoading = testStatus === 'loading';
    var selectedOption = fileUploadData[IS_CUSTOM_BUCKET_ENABLED]
        ? 'custom'
        : 'default';
    var optionsForObjectACL = [
        'public-read',
        'private',
        'bucket-owner-full-control',
    ];
    var customS3Details = fileUploadData[CUSTOM_S3_BUCKET_DETAILS];
    var onSelectionChange = react_1.useCallback(function (index) {
        var _a;
        var updatedFileUploadData = __assign(__assign({}, utils_2.getInitialFileUploadData(options[index].value === 'custom')), (_a = {}, _a[ALLOWED_S3_REGIONS] = fileUploadData[ALLOWED_S3_REGIONS], _a));
        onChange(FILE_UPLOAD_DETAILS, updatedFileUploadData, null, true);
        setFileUploadData(updatedFileUploadData);
    }, [options, fileUploadData]);
    var onCustomFieldsChange = function (key, fieldValue, isMandatory) {
        var _a, _b;
        var updatedValue = __assign(__assign({}, fileUploadData), (_a = {}, _a[CUSTOM_S3_BUCKET_DETAILS] = __assign(__assign({}, customS3Details), (_b = {}, _b[key] = typeof fieldValue === 'string' ? fieldValue.trim() : fieldValue, _b)), _a));
        onChange(FILE_UPLOAD_DETAILS, updatedValue, null, isMandatory);
        setFileUploadData(updatedValue);
    };
    var renderCustomBucketFields = function () {
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(styledComponents_1.StyledTextInput, { themed: true, label: "Bucket ARN*", placeholder: "Enter your bucket arn here", value: customS3Details[BUCKET_ARN], onChange: function (val) { return onCustomFieldsChange(BUCKET_ARN, val, true); }, disabled: utils_1.isProduction() }),
            react_1["default"].createElement(styledComponents_1.StyledTextInput, { themed: true, label: "S3 Bucket Name*", placeholder: "Enter your S3 bucket name here", value: customS3Details[S3_BUCKET_NAME], onChange: function (val) { return onCustomFieldsChange(S3_BUCKET_NAME, val, true); }, disabled: utils_1.isProduction() }),
            react_1["default"].createElement(styledComponents_1.StyledTextInput, { themed: true, label: "Directory", placeholder: "Enter directory name", value: customS3Details[DIRECTORY], onChange: function (val) { return onCustomFieldsChange(DIRECTORY, val, false); }, disabled: utils_1.isProduction() }),
            react_1["default"].createElement(dropdown_1["default"], { themed: true, label: "Bucket Region*", placeholder: "Select bucket region", value: customS3Details[BUCKET_REGION], options: fileUploadData[ALLOWED_S3_REGIONS], onChange: function (val) { return onCustomFieldsChange(BUCKET_REGION, val, true); }, style: { marginTop: '32px', width: '500px' }, disabled: utils_1.isProduction() }),
            react_1["default"].createElement(dropdown_1["default"], { themed: true, label: "Object ACL*", placeholder: "Private or Public", value: optionsForObjectACL.find(function (option) { return option === customS3Details[OBJECT_ACL]; }), options: fileUploadData[ALLOWED_OBJECT_ACLS] || optionsForObjectACL, onChange: function (val) { return onCustomFieldsChange(OBJECT_ACL, val, true); }, style: { marginTop: '32px', width: '500px' }, disabled: utils_1.isProduction() }),
            customS3Details[OBJECT_ACL] !== 'public-read' && (react_1["default"].createElement(styledComponents_1.StyledTextInput, { themed: true, label: "URL Expiry Time*", placeholder: "Enter url expiry time here(in seconds)", value: customS3Details[EXPIRY], controlledInput: true, onChange: function (val) {
                    var valNum = Number(val.trim());
                    var updatedValue = Number.isNaN(valNum)
                        ? customS3Details[EXPIRY]
                        : valNum;
                    if (!val.trim())
                        updatedValue = undefined;
                    if (updatedValue !== customS3Details[EXPIRY])
                        onCustomFieldsChange(EXPIRY, updatedValue, true);
                }, error: Number(customS3Details[EXPIRY]) > 604800
                    ? 'Expiry Time cannot exceed 604800(7 days)'
                    : null, disabled: utils_1.isProduction() }))));
    };
    var renderInfoContainer = react_1.useCallback(function () {
        var info = [
            "Please reach out to the Haptik DevOps team and get Haptik's ARN Number.",
            'Please provide access to the Haptik ARN Number so that it can upload and get objects from your S3 Bucket.',
            'Please ensure that the Haptik DevOps team has granted the necessary access to the above ARN so that it can connect with your S3 Bucket.',
            'Please note, that by using a Custom S3 Bucket, all user and agent-uploaded files will henceforth be uploaded to this Bucket only. The responsibility for these files will also rest with you.',
        ];
        return (react_1["default"].createElement(styledComponents_1.InfoContainer, null,
            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Important information regarding S3 Bucket"),
            info.map(function (infoText, index) { return (react_1["default"].createElement(styledComponents_1.InfoTextRow, null,
                react_1["default"].createElement(styledComponents_1.InfoTextRowNumber, { variant: "h5.semi-bold" }, index + 1),
                react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold" }, infoText))); })));
    }, []);
    var testConnection = function () {
        var file = new File(['sample'], 'sample.pdf', {
            type: 'application/pdf',
        });
        upload_1.uploadFile(file, function () { }, function () { return setTestStatus('success'); }, function () { return setTestStatus('failure'); }, businessId, 1);
        setTestStatus('loading');
    };
    var renderTestConnectionButton = function () {
        var getButtonText = function () {
            if (isSuccessful)
                return 'Connection Successful!';
            if (isFailure)
                return 'Connection Failed!';
            return 'Test Connection';
        };
        return (react_1["default"].createElement(styledComponents_1.StyledButton, { themed: true, variant: (businessDataEdited && testStatus === 'initial') || utils_1.isProduction()
                ? 'disabled'
                : 'secondary', onClick: function () {
                if (isInitial)
                    testConnection();
            }, isInitial: isInitial, isSuccessful: isSuccessful, isFailure: isFailure, isLoading: isLoading, disabled: (businessDataEdited && testStatus === 'initial') || utils_1.isProduction() }, isLoading ? (react_1["default"].createElement(loader_1["default"], { prefixClassName: "loader", size: 20 })) : (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold" }, getButtonText()),
            testStatus === 'success' && (react_1["default"].createElement(TickIconV2_1["default"], { size: "small", iconColor: "green.deep" })),
            testStatus === 'failure' && (react_1["default"].createElement(CloseIconV4_1["default"], { size: "small", iconColor: "red.haptik" }))))));
    };
    react_1.useEffect(function () {
        setFileUploadData(value);
    }, []);
    react_1.useEffect(function () {
        if (!businessDataEdited)
            setTestStatus('initial');
    }, [businessDataEdited]);
    return (react_1["default"].createElement(box_1["default"], { flexDirection: "column", padding: "0" },
        options.map(function (option, index) { return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(styledComponents_1.RadioItem, { label: option.label, value: option.value === selectedOption, isCustom: option.value === 'custom', onChange: function () { return onSelectionChange(index); }, disabled: utils_1.isProduction() }),
            !fileUploadData[IS_CUSTOM_BUCKET_ENABLED] &&
                option.value === 'default' && (react_1["default"].createElement(styledComponents_1.DefaultInfo, null,
                react_1["default"].createElement("div", null,
                    react_1["default"].createElement(InfoIconV4_1["default"], { size: "medium", iconColor: "yellow.dark" })),
                react_1["default"].createElement(text_1["default"], { variant: "body.md" }, option.tooltip))))); }),
        fileUploadData[IS_CUSTOM_BUCKET_ENABLED] && (react_1["default"].createElement(react_1["default"].Fragment, null,
            renderCustomBucketFields(),
            renderInfoContainer(),
            renderTestConnectionButton()))));
};
exports["default"] = FileUpload;
